import React from 'react';
import { Input } from 'components/UI/V3/Forms/Input/Input';
import styles from './TransportationLocationSection.module.scss';

interface TransportationLocationSectionProps {
    title?: string;
    addressLabel: string;
    instructionsLabel: string;
    address?: string;
    instructions?: string;
    onAddressChange?: (value: string) => void;
    onInstructionsChange?: (value: string) => void;
    addressDisabled?: boolean;
    instructionsDisabled?: boolean;
}

export const TransportationLocationSection: React.FC<TransportationLocationSectionProps> = ({
    title,
    addressLabel,
    instructionsLabel,
    address = '',
    instructions = '',
    onAddressChange,
    onInstructionsChange,
    addressDisabled,
    instructionsDisabled
}) => {
    const handleAddress = (value: string) => {
        onAddressChange?.(value);
    };

    const handleInstructions = (value: string) => {
        onInstructionsChange?.(value);
    };

    return (
        <div className={styles.container}>
            {title && <label className={styles.title}>{title}</label>}

            <p className={styles.title}>{addressLabel}</p>
            <Input
                value={address}
                disabled={addressDisabled}
                placeholder="Enter address"
                className={styles.input}
                onChange={e => handleAddress(e.target.value)}
            />

            <p className={styles.title}>{instructionsLabel}</p>
            <Input
                value={instructions}
                disabled={instructionsDisabled}
                placeholder="Enter instructions"
                className={styles.input}
                onChange={e => handleInstructions(e.target.value)}
            />
        </div>
    );
};

export default TransportationLocationSection;
